import { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export const DEFAULT_SCALE = 'scale(1.4)'

export const DEFAULT_VIDEO_SRC = {
  DESKTOP: '',
  MOBILE: '',
}

export const getVideoPlayerDevice = () => {
  if (!isBrowser()) return DEVICE_TYPES.DESKTOP
  const isMobileQuery = window.matchMedia(`(max-width:  960px)`)
  if (isMobileQuery.matches) {
    return DEVICE_TYPES.MOBILE
  }
  return DEVICE_TYPES.DESKTOP
}

export const getEcodingForVideo = (videoSrc: string) => {
  if (videoSrc?.endsWith('m3u8')) return 'application/x-mpegURL'
  return 'application/dash+xml'
}
